import fetchApi from '../../Services/requests';
import {
  GetOtpCodeUrl,
  ResendOtpUrl,
  SendOtpUrl
} from '../../Routes/account.route';
import useProfileStore from '../Profile';
import useLandingStore from '../Landing';

export const getOtpCodeAction = async (
  set,
  phoneNumber: string,
  branchId: number
): Promise<boolean> => {
  set({ otpRequestLoading: true, otpRequestError: false });
  const response = await fetchApi(GetOtpCodeUrl(), { phoneNumber, branchId });

  if (response?.ok) {
    set({ otpRequestLoading: false, phoneNumber: phoneNumber });
    return true;
  } else {
    set({ otpRequestLoading: false, otpRequestError: true });
    return false;
  }
};

export const sendOtpCodeAction = async (
  set,
  phoneNumber: string,
  confirmationCode: string,
  uniqueId: number,
  navigate
): Promise<void> => {
  set({ sendOtpLoading: true, sendOtpError: false });
  const response = await fetchApi(SendOtpUrl(), {
    phoneNumber,
    confirmationCode,
    uniqueId
  });

  if (response?.ok) {
    set({ sendOtpLoading: false });
    localStorage.setItem('access_token', response.data.access_token);
    localStorage.setItem('refresh_token', response.data.refresh_token);

    // Get landing data to get the correct branch ID
    const landingStore = useLandingStore.getState();
    const landingData = landingStore.landingData;

    if (landingData?.branchId) {
      // Get profile data to check if it's complete
      const profileStore = useProfileStore.getState();
      const profileComplete = await profileStore.getProfileDataAction(
        landingData.branchId
      );

      if (profileComplete) {
        const profileData = profileStore.profileData;
        const isProfileIncomplete = !profileData?.name || !profileData?.sex;

        if (isProfileIncomplete) {
          navigate('/profile/edit', {
            state: {
              name: profileData?.name || '',
              birthday: profileData?.birthday,
              email: profileData?.email ?? '',
              mobile: profileData?.mobile,
              sex: profileData?.sex || ''
            }
          });
        } else {
          navigate('/credits', { replace: true });
        }
      } else {
        navigate('/credits', { replace: true });
      }
    } else {
      // If we don't have landing data yet, just go to credits
      navigate('/credits', { replace: true });
    }
  } else {
    set({ sendOtpLoading: false, sendOtpError: true });
  }
};

export const resendOtpCodeAction = async (
  set,
  phoneNumber: string,
  branchId: number
): Promise<boolean> => {
  set({
    otpRequestLoading: true,
    otpRequestError: false,
    sendOtpError: false,
    sendOtpLoading: false
  });
  const response = await fetchApi(ResendOtpUrl(), { phoneNumber, branchId });

  if (response?.ok) {
    set({ otpRequestLoading: false });
    return true;
  } else {
    set({ otpRequestLoading: false, otpRequestError: true });
    return false;
  }
};
